import Apples from "./images/Apples.png";
import Asparagus from "./images/Asparagus.png";
import Aspartame from "./images/Aspartame.png";
import Broccoli from "./images/Broccoli.png";
import BrusselsSprouts from "./images/BrusselsSprouts.png";
import Cashews from "./images/Cashews.png";
import Chips from "./images/Chips.png";
import ChocolateCheese from "./images/ChocolateCheese.png";
import CoconutMilk from "./images/CoconutMilk.png";
import CookedSpinach from "./images/CookedSpinach.png";
import Cornflakes from "./images/Cornflakes.png";
import CornStarch from "./images/CornStarch.png";
import DriedApricots from "./images/DriedApricots.png";
import FishFingers from "./images/FishFingers.png";
import Gelatin from "./images/Gelatin.png";
import InstantPotatoPorridge from "./images/InstantPotatoPorridge.png";
import Margarine from "./images/Margarine.png";
import MilkChocolate from "./images/MilkChocolate.png";
import Peaches from "./images/Peaches.png";
import Pears from "./images/Pears.png";
import Raisins from "./images/Raisins.png";
import Sardels from "./images/Sardels.png";
import SourCream from "./images/SourCream.png";
import SunflowerSeeds from "./images/SunflowerSeeds.png";
import Swede from "./images/Swede.png";
import Tofu from "./images/Tofu.png";
import Veal from "./images/Veal.png";
import WalnutOil from "./images/WalnutOil.png";
import Yolk from "./images/Yolk.png";
import Zucchini from "./images/Zucchini.png";

export const renderImage = (product: string) => {
    return (
        <>
            <img className={product === "Peaches" ? "productImage" : "hidden"} src={Peaches} alt={"CornStarch"} />
            <img className={product === "Corn starch" ? "productImage" : "hidden"} src={CornStarch} alt={"CornStarch"} />
            <img className={product === "Walnut oil" ? "productImage" : "hidden"} src={WalnutOil} alt={"WalnutOil"} />
            <img className={product === "Margarine" ? "productImage" : "hidden"} src={Margarine} alt={"Margarine"} />
            <img className={product === "Sour cream" ? "productImage" : "hidden"} src={SourCream} alt={"SourCream"} />
            <img className={product === "Yolk" ? "productImage" : "hidden"} src={Yolk} alt={"Yolk"} />
            <img className={product === "Zucchini" ? "productImage" : "hidden"} src={Zucchini} alt={"Zucchini"} />
            <img className={product === "Gelatin" ? "productImage" : "hidden"} src={Gelatin} alt={"Gelatin"} />
            <img className={product === "Sunflower seeds" ? "productImage" : "hidden"} src={SunflowerSeeds} alt={"SunflowerSeeds"} />
            <img className={product === "Tofu" ? "productImage" : "hidden"} src={Tofu} alt={"Tofu"} />
            <img className={product === "Cornflakes" ? "productImage" : "hidden"} src={Cornflakes} alt={"Cornflakes"} />
            <img className={product === "Chips" ? "productImage" : "hidden"} src={Chips} alt={"Chips"} />
            <img className={product === "Brussels sprouts" ? "productImage" : "hidden"} src={BrusselsSprouts} alt={"BrusselsSprouts"} />
            <img className={product === "Apples" ? "productImage" : "hidden"} src={Apples} alt={"Apples"} />
            <img className={product === "Broccoli" ? "productImage" : "hidden"} src={Broccoli} alt={"Broccoli"} />
            <img className={product === "Cooked spinach" ? "productImage" : "hidden"} src={CookedSpinach} alt={"CookedSpinach"} />
            <img className={product === "Milk chocolate" ? "productImage" : "hidden"} src={MilkChocolate} alt={"MilkChocolate"} />
            <img className={product === "Sardels" ? "productImage" : "hidden"} src={Sardels} alt={"Sardels"} />
            <img className={product === "Raisins" ? "productImage" : "hidden"} src={Raisins} alt={"Raisins"} />
            <img className={product === "Fish fingers" ? "productImage" : "hidden"} src={FishFingers} alt={"FishFingers"} />
            <img className={product === "Chocolate cheese" ? "productImage" : "hidden"} src={ChocolateCheese} alt={"ChocolateCheese"} />
            <img className={product === "Cashews" ? "productImage" : "hidden"} src={Cashews} alt={"Cashews"} />
            <img className={product === "Coconut milk" ? "productImage" : "hidden"} src={CoconutMilk} alt={"CoconutMilk"} />
            <img className={product === "Aspartame" ? "productImage" : "hidden"} src={Aspartame} alt={"Aspartame"} />
            <img className={product === "Pears" ? "productImage" : "hidden"} src={Pears} alt={"Pears"} />
            <img className={product === "Instant potato porridge" ? "productImage" : "hidden"} src={InstantPotatoPorridge} alt={"InstantPotatoPorridge"} />
            <img className={product === "Veal" ? "productImage" : "hidden"} src={Veal} alt={"Veal"} />
            <img className={product === "Dried apricots" ? "productImage" : "hidden"} src={DriedApricots} alt={"DriedApricots"} />
            <img className={product === "Swede" ? "productImage" : "hidden"} src={Swede} alt={"Swede"} />
            <img className={product === "Asparagus" ? "productImage" : "hidden"} src={Asparagus} alt={"Asparagus"} />
        </>
    );
}
